import { createFrontendFeatureLoader } from '@backstage/frontend-plugin-api';
import { techRadarModule } from './apis/techRadar';
import { governancePlugin } from './plugin';

export { governancePlugin, techRadarModule };

/**
 * Export por defecto usado por `app.packages: all`: solo se descubre el
 * `default` de cada paquete. Un cargador de features entrega a la vez el
 * plugin de gobernanza y el módulo que reemplaza el API de Tech Radar.
 */
export default createFrontendFeatureLoader({
  loader: () => [governancePlugin, techRadarModule],
});
